/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Alert,
  Col,
  Row,
  Card,
  Accordion,
  Button,
  Form,
} from "react-bootstrap";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { InssuredData } from "../../subPages/InsuredData/InssuredData";
import { HospitalData } from "../../subPages/HospitalData/HospitalData";
import { Documentation } from "../../subPages/Documentation/Documentation";
import { Binnacle } from "../../subPages/Binnacle/Binnacle";
import { CostControlData } from "../../subPages/CostControlData/CostControlData";
import AuthLetters from "../../subPages/AuthLetter/AuthLetters";
import {
  getBySlug,
  update,
} from "../../services/hospitalizationcrud";
import { getLasMcMovementtByCase } from "../../services/mcMovementsService";
import { getLastLetterMovByCase } from "../../services/letterMovsService";
import { isEmpty } from "../../../_utils/checkObjectEmpty";
import moment from "moment";
import CaseHeader from "../../subPages/CaseHeader/CaseHeader";
import BlockCaseContext from "../../../contexts/BlockCaseContext";
import $ from "jquery";

const CostControlDetails = (props) => {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Control de Costos");

  const { slug } = props.match.params;

  const [caseRecord, setCaseRecord] = useState({});
  const [mcMovement, setMcMovement] = useState({});
  const [letterMov, setLetterMov] = useState({});
  const [totalLetters, setTotalLetters] = useState(0);
  const [shouldBlockCase, setShouldBlockCase] = useState(true);

  useEffect(() => {
    window.wasCommented = false;
    getBySlug(slug).then((response) => {
      setCaseRecord(response.data);
      getLasMcMovementtByCase(response.data.id).then((currentMcMovemet) =>
        setMcMovement(currentMcMovemet.data)
      );
      getLastLetterMovByCase(response.data.id).then((currrentLetterMov) =>
        setLetterMov(currrentLetterMov.data)
      );
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  let history = useHistory();

  let submitFormCostControlData = null;
  let submitFormCostControlDataErrors = null;

  const query = new URLSearchParams(props.location.search);

  const bindSubmitFormCostControlData = (submitForm) =>
    (submitFormCostControlData = submitForm);

  const bindSubmitFormCostControlDataErrors = (errors) =>
    (submitFormCostControlDataErrors = errors);

  const onClickSendDictum = async () => {
    await submitFormCostControlData();
    if (isEmpty(submitFormCostControlDataErrors)) {
      let inputReasonDictum = document.getElementById("reason_sendToDictum").value;
      if (inputReasonDictum === "") {
        alert("Debe seleccionar una razon");
        return;
      }
      if (!window.wasCommented) {
        alert("Debe ingresar un comentario");
        return;
      }
      $("#btn_save_comment").click();
      let timestamp = await axios.get('/cases/localDateTime');
      update({ caseStatusId: 5, dictumReason: inputReasonDictum, feadictamen: moment.utc(timestamp.data).format()}, 
        caseRecord.id
        ).then((response) => {
        history.push("/control_costos");
      });
    }
  }

  const onClickPatientStore = async () => {
    await submitFormCostControlData();
    if (isEmpty(submitFormCostControlDataErrors)) {
      if (!window.wasCommented) {
        alert("Debe ingresar un comentario");
        return;
      }
      $("#btn_save_comment").click();
      let timestamp = await axios.get('/cases/localDateTime');
      update(
        { caseStatusId: 7, feaapaciente: moment.utc(timestamp.data).format()}, 
        caseRecord.id
        ).then((response) => {
        history.push("/control_costos");
      });
    }
  }

  const onClickSendMedicInformation = async () => {
    await submitFormCostControlData();
    if (isEmpty(submitFormCostControlDataErrors)) {
      const informationReason = document.getElementById(
        "reason_sendToMedicInformation"
      ).value;
      if (informationReason === "") {
        alert("Debe seleccionar una razón");
        return;
      }
      if (!window.wasCommented) {
        alert("Debe ingresar un comentario");
        return;
      }
      $("#btn_save_comment").click();
      const timestamp = await axios.get('/cases/localDateTime');
      update({
        caseStatusId: 4,
        informationReason,
        feaimedica: moment.utc(timestamp.data).format(),
      }, caseRecord.id).then(() => {
        history.push("/control_costos");
      });
    }
  }

  return (
    <>
      <Alert
        variant="success"
        className="text-center"
        style={{ fontSize: "16px" }}
      >
        Control de Costos
      </Alert>

      <CaseHeader
        caseRecord={caseRecord}
        hideComprehensiveCare={true}
        hideRequiresTabulation={true}
        hideHospitalModel={true}
        showFolioEp={true}
        showPolicy={true}
      />

      <BlockCaseContext.Provider value={[shouldBlockCase, setShouldBlockCase]}>
      <Accordion defaultActiveKey={query.has("from") && query.get("from") === "control_board" ? "" : "0"} className="mt-5">
        <InssuredData
          icon="fa-search"
          eventKey="1"
          data={caseRecord}
          disabledAll={true}
          bindSubmitForm={()=>{}}
        />
        <HospitalData
          icon="fa-search"
          eventKey="2"
          data={caseRecord}
          disabledAll={true}
          bindSubmitForm={()=>{}}
        />
        <CostControlData
          icon="fa-pencil-alt"
          eventKey="0"
          data={caseRecord}
          mcMovement={mcMovement}
          letterMov={letterMov}
          totalLetters={totalLetters}
          disabledAll={query.has("from") && query.get("from") === "control_board"}
          showForm={true}
          bindSubmitForm={bindSubmitFormCostControlData}
          bindErrors={bindSubmitFormCostControlDataErrors}
          totalDeviations={caseRecord.hospital?.atc?.toLowerCase() === 'no'}
        />
        <AuthLetters
          icon="fa-search"
          showForm={false}
          hideDeleteOption={true}
          eventKey="3"
          data={caseRecord}
          disabledAll={false}
          setTotalLetters={setTotalLetters}
          {...props}
        />
        <Documentation
          icon ="fa-search"
          eventKey="4"
          data={caseRecord}
          disabledAll={query.has("from") && query.get("from") === "control_board"}
          allowSelectiveDownload={true}
          typesDocument={[
            "Aviso de Accidente", "Carta de Autorización", "Comprobante de seguro o poliza", "Denuncia ante MP",
            "Estudios de Gabinete", "Estudios de Laboratorio", "Estudios que Confirmen DX", "Historia Clinica",
            "Honorarios Médicos", "Identificacion", "Informe Medico Actualizado", "Nota de Evolución",
            "Nota Postquirurgica", "Resumen Medico Actualizado", "Visado Final", "Otro",
          ]}
          {...props}
        />
      </Accordion>
      <Accordion defaultActiveKey="5" className="mt-5">
        <Binnacle
          icon="fa-pencil-alt"
          eventKey="5"
          data={caseRecord}
          disabledAll={false}
          eventStage="Control de Costos"
          {...props}
        />
      </Accordion>
      </BlockCaseContext.Provider>

      <Row hidden={query.has("from") && query.get("from") === "control_board"}>
        <Col className="mt-5">
          <Button variant="warning" onClick={onClickSendMedicInformation}>
            Enviar a Informacion Médica Hospital
          </Button>

          <Form.Control
            className="mt-5 mr-3"
            as="select"
            name="reason_sendToMedicInformation"
            id="reason_sendToMedicInformation"
          >
            <option value="">Selecciona una opcion...</option>
            <option value="Revaloración Estado de cuenta">
              Revaloración Estado de cuenta
            </option>
          </Form.Control>
        </Col>

        <Col className="mt-5">
          <Button variant="danger" onClick={onClickSendDictum}>
            Enviar a Dictamen
          </Button>

          <Form.Control
            className="mt-5 mr-3"
            as="select"
            name="reason_sendToDictum"
            id="reason_sendToDictum"
          >
            <option value="">Selecciona una opcion...</option>
            <option value="Carta Erronea">Carta Erronea</option>
            <option value="Monto en Carta Insuficiente">Monto en Carta Insuficiente</option>
          </Form.Control>
        </Col>

        {caseRecord.caseType !== "Revision de corte" &&
        <Col>
          <Button
            className="mt-5"
            variant="success"
            onClick={onClickPatientStore}
          >
            Enviar a Alta Paciente
          </Button>
        </Col>}
      </Row>
    </>
  );
};

export default CostControlDetails;
